// Export helpers for the list pages: fetch every row of the current search / filter, then save a CSV.

const MAX_PAGES = 400;

/**
 * Walks a paginated list API until it runs dry. `fetchPage(index, limit)` resolves to the array of rows
 * for that page. Stops at an empty page, a short page, or a page that brings nothing new.
 */
export const fetchAllRows = async (fetchPage, keyOf, limit = 500) => {
  const seen = new Set();
  const all = [];
  for (let page = 0; page < MAX_PAGES; page += 1) {
    const rows = await fetchPage(all.length, limit);
    if (!Array.isArray(rows) || rows.length === 0) break;
    let fresh = 0;
    rows.forEach((row) => {
      const key = keyOf(row);
      if (key === undefined || key === null || !seen.has(key)) {
        if (key !== undefined && key !== null) seen.add(key);
        all.push(row);
        fresh += 1;
      }
    });
    if (fresh === 0 || rows.length < limit) break;
  }
  return all;
};

// A cell that starts with = @ (or + / - followed by a non-digit) would be run as a formula by Excel.
const cell = (value) => {
  let text = value === undefined || value === null ? "" : String(value);
  if (/^[=@]/.test(text) || /^[+-][^0-9]/.test(text)) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** Saves `rows` (arrays of values) under `headers` as a CSV that Excel opens with the right encoding. */
export const downloadCsv = (filename, headers, rows) => {
  const body = [headers, ...rows].map((r) => r.map(cell).join(",")).join("\r\n");
  const blob = new Blob(["﻿" + body], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
